import type { ReactNode } from 'react';

export const symbol_switch_access_shortcut: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M538-783q-71 54-110.5 132.5T388-483q0 99 47.5 184T568-163q11 7 16.5 19.5T583-120q-7 11-20 14t-25-4q-98-60-154-158.5T328-482q0-99 42-187.5T489-820H352q-13 0-21.5-8.5T322-850q0-13 8.5-21.5T352-880h216q13 0 21.5 8.5T598-850v216q0 13-8.5 21.5T568-604q-13 0-21.5-8.5T538-634v-149Z"
		/>
	</svg>
);
